import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=cb890c2c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb890c2c')) {
      api.createRecord('cb890c2c', component.options)
    } else {
      api.reload('cb890c2c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=cb890c2c&", function () {
      api.rerender('cb890c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f1zlIczwxeZa/JS/comp/ImgFallback.vue"
export default component.exports